/* eslint-disable */
import React, { Component, Button } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BookingsTable from './table';
import actions from '../../../actions';
import { withRefreshTableOnFilterChange } from '../common/decorators';

import history from '../../../history';

@withRefreshTableOnFilterChange
class Bookings extends Component {
    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        this.props.load(currentUrlParams);
    }

    render() {
        let pages = -1;
        let showPaginationBottom = false;
        if (this.props.content && this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }

        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <BookingsTable
                data={this.props.content}
                pages={pages}
                showPaginationBottom={showPaginationBottom}
                loading={this.props.fetching}
                user={this.props.user}
                notification={this.props.notification}
                location={this.props.location}
                match={this.props.match}
                history={history}
                meta={this.props.meta}
                reloadData={() => {
                    this.props.load(currentUrlParams);
                }}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    ...state.bookings,
    user: state.user,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    load: searchParams => dispatch(actions.loadBookings(searchParams)),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Bookings),
);
